import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-download-white.png'

const DownloadBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default DownloadBtn
